import { render, staticRenderFns } from "./CardChoose.vue?vue&type=template&id=131f1d90&scoped=true&"
import script from "./CardChoose.vue?vue&type=script&lang=js&"
export * from "./CardChoose.vue?vue&type=script&lang=js&"
import style0 from "./CardChoose.vue?vue&type=style&index=0&id=131f1d90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f1d90",
  null
  
)

export default component.exports